import styled from "styled-components";
export const BodyContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
  color: #333;
  direction: ${(props) => props.dir};
`;